import React from 'react'
import HeaderContainerBg from '../../public/reservation_form_mv_bg-pc.png'
import ReservationFormMvPc from '../../public/reservation_form_mv-pc.png'
import ReservationFormMvSp from '../../public/reservation_form_mv-sp.png'
import ReservationMoveButton from '../../components/ReservationMoveButton'
import { ContentType } from '../../types/trialLessons'
import { THRESHOLD_SP_WIDTH } from '../../utils/constants'

const TrialHeader = ({
  isShowCTA = true,
  contentType,
  label,
  isCountdownActive,
}: {
  isShowCTA?: boolean
  contentType?: ContentType
  label?: string
  isCountdownActive?: boolean
}) => {
  return (
    <>
      <section
        className="mx-auto text-center bg-cover pt-10 pb-16 sp:pt-0 sp:pb-6"
        style={{
          backgroundImage: `url(${HeaderContainerBg.src})`,
          marginTop: isCountdownActive ? 44 : 0,
        }}
      >
        <div className="mb-10">
          <picture>
            <source
              media={`(max-width: ${THRESHOLD_SP_WIDTH}px)`}
              srcSet={ReservationFormMvSp.src}
            />
            <img
              src={ReservationFormMvPc.src}
              alt=""
              className="max-w-full mx-auto desktop:max-w-[750px]"
            />
          </picture>
        </div>
        {isShowCTA && (
          <ReservationMoveButton
            contentType={contentType}
            moveToId="reservation-step-summary"
            label={label}
          />
        )}
      </section>
    </>
  )
}

export default TrialHeader
